// extracted by mini-css-extract-plugin
export var icon = "TextLinkButton-module--icon--26983";
export var label = "TextLinkButton-module--label--1f16e";
export var root = "TextLinkButton-module--root--7fcc1";